module.exports = __webpack_public_path__ + "img/SmallOrangeOval.aa4f65c1.svg";